import Flickity from 'flickity';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

class Power {
	index = 1;
	screenCount = 8;
	DOM = {} as {
		label: HTMLElement;
		display: HTMLElement;
		screenButton: HTMLElement;
		screen: HTMLElement;
	};

	constructor() {
		this.cache();
		this.init();
	}

	cache() {
		this.DOM = {
			label: document.querySelector('.js-screenLabel') as HTMLElement,
			display: document.querySelector('.js-screenDisplay') as HTMLElement,
			screenButton: document.querySelector('.js-screenButton') as HTMLElement,
			screen: document.querySelector('.js-powerScreen') as HTMLElement,
		};
	}

	init() {
		this.DOM.label.addEventListener('click', this.cycleScreen.bind(this));
		this.DOM.display.addEventListener('click', this.cycleScreen.bind(this));
		this.DOM.screen.addEventListener('click', this.cycleScreen.bind(this));
		this.DOM.screenButton.addEventListener('click', this.cycleScreen.bind(this));
	}

	cycleScreen() {
		const newScreen = this.index === this.screenCount ? 1 : this.index + 1;
		this.DOM.screen.style.backgroundImage = `url(${powerScreenImagePath}${newScreen}.jpg)`;
		this.index = newScreen;
	}
}
new Power();

class PowerUses {
	DOM = {} as { rotator: HTMLElement };
	flkty: FlickityInstance;

	constructor() {
		this.cache();
		if (window.innerWidth < 1000) {
			this.initRotator();
		}
	}

	cache() {
		this.DOM = {
			rotator: document.querySelector('.js-usesRotator') as HTMLElement,
		};
	}

	initRotator() {
		this.flkty = new Flickity(this.DOM.rotator, {
			autoPlay: true,
			cellAlign: 'left',
			pageDots: false,
			pauseAutoPlayOnHover: false,
			prevNextButtons: false,
			wrapAround: true,
		}) as unknown as FlickityInstance;
	}
}
new PowerUses();

class PowerIntegration {
	current = 1;
	config = {
		playing: false,
		directory: 'integrate-560-png8',
		start: 1,
		height: 414,
		width: 559,
		count: 25,
		frames: [] as HTMLImageElement[],
		version: '0.0.1',
	};
	DOM = {} as {
		canvas: HTMLCanvasElement;
		canvas2d: CanvasRenderingContext2D;
	};

	constructor() {
		this.cache();
		this.init();
	}

	cache() {
		const canvas = document.querySelector('.js-integrationCanvas') as HTMLCanvasElement;
		this.DOM = {
			canvas,
			canvas2d: canvas.getContext('2d') as CanvasRenderingContext2D,
		};
	}

	init() {
		this.preloadImages(this.config, (i: number) => {
			this.loadFrameAt(this.config, i);
		});
		this.initTrigger();
	}

	initTrigger() {
		ScrollTrigger.create({
			trigger: '.js-integrationCanvas',
			start: 'top 100%',
			end: `+=${window.innerHeight * 1.5}`,
			onUpdate: (e) => {
				this.scrollProgress(e);
			},
		});
	}

	scrollProgress(e: { progress: number }) {
		const factor = e.progress * 2 > 1 ? 2 - e.progress * 2 : e.progress * 2;
		const nextI = Math.floor(factor * (this.config.count - 1)) + 1;
		if (this.current !== nextI) {
			this.current = nextI;
			requestAnimationFrame(this.loadFrameAt.bind(this, this.config, nextI));
		}
	}

	preloadImages(animationObj: typeof this.config, loadCallback?: (i: number) => void) {
		for (var i = animationObj.start; i <= animationObj.count; i++) {
			var filename = ('0' + i).slice(-2) + '.png?v=' + animationObj.version;
			var img = new Image();
			img.src = integrationImagePath + '/' + animationObj.directory + '/batteryBlowup-' + filename;
			animationObj.frames[i] = img;

			if (loadCallback && i === animationObj.start) {
				img.addEventListener('load', loadCallback.bind(this, i));
			}
		}
	}

	loadFrameAt(animationObj: typeof this.config, i: number) {
		var frame = animationObj.frames[i];
		if (!frame) return;
		this.DOM.canvas2d.clearRect(0, 0, animationObj.width, animationObj.height);
		this.DOM.canvas2d.drawImage(frame, 0, 0, animationObj.width, animationObj.height);
	}
}

new PowerIntegration();
